/**
 * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
 * Original file: /npm/kdbush@4.0.2/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
const t = [
	Int8Array,
	Uint8Array,
	Uint8ClampedArray,
	Int16Array,
	Uint16Array,
	Int32Array,
	Uint32Array,
	Float32Array,
	Float64Array,
];
class r {
	static from(s) {
		if (!(s instanceof ArrayBuffer))
			throw new Error("Data must be an instance of ArrayBuffer.");
		const [n, i] = new Uint8Array(s, 0, 2);
		if (219 !== n)
			throw new Error("Data does not appear to be in a KDBush format.");
		const e = i >> 4;
		if (1 !== e) throw new Error(`Got v${e} data when expected v1.`);
		const o = t[15 & i];
		if (!o) throw new Error("Unrecognized array type.");
		const [a] = new Uint16Array(s, 2, 1),
			[h] = new Uint32Array(s, 4, 1);
		return new r(h, a, o, s);
	}
	constructor(r, s = 64, n = Float64Array, i) {
		if (isNaN(r) || r < 0)
			throw new Error(`Unpexpected numItems value: ${r}.`);
		(this.numItems = +r),
			(this.nodeSize = Math.min(Math.max(+s, 2), 65535)),
			(this.ArrayType = n),
			(this.IndexArrayType = r < 65536 ? Uint16Array : Uint32Array);
		const e = t.indexOf(this.ArrayType),
			o = 2 * r * this.ArrayType.BYTES_PER_ELEMENT,
			a = r * this.IndexArrayType.BYTES_PER_ELEMENT,
			h = (8 - (a % 8)) % 8;
		if (e < 0) throw new Error(`Unexpected typed array class: ${n}.`);
		i && i instanceof ArrayBuffer
			? ((this.data = i),
			  (this.ids = new this.IndexArrayType(this.data, 8, r)),
			  (this.coords = new this.ArrayType(this.data, 8 + a + h, 2 * r)),
			  (this._pos = 2 * r),
			  (this._finished = !0))
			: ((this.data = new ArrayBuffer(8 + o + a + h)),
			  (this.ids = new this.IndexArrayType(this.data, 8, r)),
			  (this.coords = new this.ArrayType(this.data, 8 + a + h, 2 * r)),
			  (this._pos = 0),
			  (this._finished = !1),
			  new Uint8Array(this.data, 0, 2).set([219, 16 + e]),
			  (new Uint16Array(this.data, 2, 1)[0] = s),
			  (new Uint32Array(this.data, 4, 1)[0] = r));
	}
	add(t, r) {
		const s = this._pos >> 1;
		return (
			(this.ids[s] = s),
			(this.coords[this._pos++] = t),
			(this.coords[this._pos++] = r),
			s
		);
	}
	finish() {
		const t = this._pos >> 1;
		if (t !== this.numItems)
			throw new Error(`Added ${t} items when expected ${this.numItems}.`);
		return (
			s(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0),
			(this._finished = !0),
			this
		);
	}
	range(t, r, s, n) {
		if (!this._finished)
			throw new Error("Data not yet indexed - call index.finish().");
		const { ids: i, coords: e, nodeSize: o } = this,
			a = [0, i.length - 1, 0],
			h = [];
		for (; a.length; ) {
			const d = a.pop() || 0,
				p = a.pop() || 0,
				f = a.pop() || 0;
			if (p - f <= o) {
				for (let o = f; o <= p; o++) {
					const a = e[2 * o],
						d = e[2 * o + 1];
					a >= t && a <= s && d >= r && d <= n && h.push(i[o]);
				}
				continue;
			}
			const c = (f + p) >> 1,
				y = e[2 * c],
				u = e[2 * c + 1];
			y >= t && y <= s && u >= r && u <= n && h.push(i[c]),
				(0 === d ? t <= y : r <= u) &&
					(a.push(f), a.push(c - 1), a.push(1 - d)),
				(0 === d ? s >= y : n >= u) &&
					(a.push(c + 1), a.push(p), a.push(1 - d));
		}
		return h;
	}
	within(t, r, s) {
		if (!this._finished)
			throw new Error("Data not yet indexed - call index.finish().");
		const { ids: n, coords: i, nodeSize: e } = this,
			a = [0, n.length - 1, 0],
			h = [],
			d = s * s;
		for (; a.length; ) {
			const p = a.pop() || 0,
				f = a.pop() || 0,
				c = a.pop() || 0;
			if (f - c <= e) {
				for (let s = c; s <= f; s++)
					o(i[2 * s], i[2 * s + 1], t, r) <= d && h.push(n[s]);
				continue;
			}
			const y = (c + f) >> 1,
				u = i[2 * y],
				w = i[2 * y + 1];
			o(u, w, t, r) <= d && h.push(n[y]),
				(0 === p ? t - s <= u : r - s <= w) &&
					(a.push(c), a.push(y - 1), a.push(1 - p)),
				(0 === p ? t + s >= u : r + s >= w) &&
					(a.push(y + 1), a.push(f), a.push(1 - p));
		}
		return h;
	}
}
function s(t, r, i, e, o, a) {
	if (o - e <= i) return;
	const h = (e + o) >> 1;
	n(t, r, h, e, o, a),
		s(t, r, i, e, h - 1, 1 - a),
		s(t, r, i, h + 1, o, 1 - a);
}
function n(t, r, s, e, o, a) {
	for (; o > e; ) {
		if (o - e > 600) {
			const i = o - e + 1,
				h = s - e + 1,
				d = Math.log(i),
				p = 0.5 * Math.exp((2 * d) / 3),
				f =
					0.5 *
					Math.sqrt((d * p * (i - p)) / i) *
					(h - i / 2 < 0 ? -1 : 1);
			n(
				t,
				r,
				s,
				Math.max(e, Math.floor(s - (h * p) / i + f)),
				Math.min(o, Math.floor(s + ((i - h) * p) / i + f)),
				a
			);
		}
		const h = r[2 * s + a];
		let d = e,
			p = o;
		for (i(t, r, e, s), r[2 * o + a] > h && i(t, r, e, o); d < p; ) {
			for (i(t, r, d, p), d++, p--; r[2 * d + a] < h; ) d++;
			for (; r[2 * p + a] > h; ) p--;
		}
		r[2 * e + a] === h ? i(t, r, e, p) : (p++, i(t, r, p, o)),
			p <= s && (e = p + 1),
			s <= p && (o = p - 1);
	}
}
function i(t, r, s, n) {
	e(t, s, n), e(r, 2 * s, 2 * n), e(r, 2 * s + 1, 2 * n + 1);
}
function e(t, r, s) {
	const n = t[r];
	(t[r] = t[s]), (t[s] = n);
}
function o(t, r, s, n) {
	const i = t - s,
		e = r - n;
	return i * i + e * e;
}
export { r as default };



// WEBPACK FOOTER //
// ./project/client/src/vendor/googlemaps/kdbush-v4.0.2.esm.js